export function getCSRFToken(): string {
  const value = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith("csrftoken="));

  if (!value) {
    return "";
  }

  return decodeURIComponent(value.split("=")[1] ?? "");
}
